<ng-template [ngIf]="this.showValue">
  <ng-content></ng-content>
</ng-template>
<ng-template [ngIf]="!this.showValue">
  <span style="text-shadow: 0 0 10px black; color: transparent;">{{blurText ? blurText : value}}</span>
  <button style="line-height: inherit" mat-stroked-button (click)="view()">{{this.buttonCaption}}</button>
</ng-template>
